import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
const { persistAtom } = recoilPersist();

export const todayState = atom({
  key: "todayState",
  default: 0,
  effects_UNSTABLE: [persistAtom],
});
